import { getCookie } from 'cookies-next'

// google cookie get
export function getPclick() {
  return (
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('p_click')) ||
    getCookie('p_click') ||
    null
  )
}
